import './_blurb-list.vertical.scss';

/**
 * Column layout for BlurbList - displays items in a responsive grid.
 */
export default function BlurbListVertical({ children, className = '' }) {
  if (!children) return null;

  return <div className={`BlurbList BlurbList__vertical ${className}`}>{children}</div>;
}
